import { render, staticRenderFns } from "./shopGoods.vue?vue&type=template&id=46011626&scoped=true&"
import script from "./shopGoods.vue?vue&type=script&lang=js&"
export * from "./shopGoods.vue?vue&type=script&lang=js&"
import style0 from "./shopGoods.vue?vue&type=style&index=0&id=46011626&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46011626",
  null
  
)

export default component.exports